
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SetMasterGrid extends Serenity.EntityGrid<SetMasterRow, any> {
        protected getColumnsKey() { return 'Inventory.SetMaster'; }
        protected getDialogType() { return SetMasterDialog; }
        protected getIdProperty() { return SetMasterRow.idProperty; }
        protected getInsertPermission() { return SetMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return SetMasterRow.localTextPrefix; }
        protected getService() { return SetMasterService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}